var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:_vm.getButtonType()},[_c('p',{class:_vm.buttonType,domProps:{"innerHTML":_vm._s(_vm.msg)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }